import { render, staticRenderFns } from "./ManageDrug.vue?vue&type=template&id=c4ab0958&scoped=true&"
import script from "./ManageDrug.vue?vue&type=script&lang=js&"
export * from "./ManageDrug.vue?vue&type=script&lang=js&"
import style0 from "./ManageDrug.vue?vue&type=style&index=0&id=c4ab0958&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ab0958",
  null
  
)

export default component.exports